export const DEMO_CONTRACT_STORAGE_KEY = "neo_demo_contract_pending_v1";
export const POST_AUTH_INTENT_KEY = "neo_post_auth_intent";
export const DEMO_INTENT = "demo-contract";

/** Templates available in public demo mode (system models only). */
export const DEMO_TEMPLATE_IDS = [
  "compromisso-compra-venda",
  "contrato-locacao-imovel",
  "recibo-simples",
];

export const DEMO_STORAGE_TTL_MS = 24 * 60 * 60 * 1000;

export const DEMO_PUBLIC_ROUTE = "/conhecer";
